import { cn } from '@workspace/ui/lib/utils'
import { Eye, ThumbsUp } from 'lucide-react'

// The two automated warm-up actions the campaign runs before the connection
// request goes out (the `viewedProfileAt` / `likedPostAt` signals). They are
// handled for the founder — nothing to write or approve — so they render as a
// quiet, non-editable lead-in above the first editable message. Mirrors the
// MessageBubble layout (right-aligned, uppercase label) so it sits naturally in
// the conversation column of both the investor and portfolio message editors.
const WARMUP_STEPS = [
  { icon: Eye, label: 'View their profile' },
  { icon: ThumbsUp, label: 'Like a recent post' },
] as const

// `labelAlign` matches the sibling message bubble's label: the editor lays its
// label out on the left (justify-between row), the roster preview on the right
// (items-end), so WARM UP lines up with CONNECTION REQUEST in each view.
export function WarmupSteps({ labelAlign = 'left' }: { labelAlign?: 'left' | 'right' }) {
  return (
    <div className="flex flex-col items-end">
      <div className={cn('mb-1 w-full max-w-[88%]', labelAlign === 'right' && 'text-right')}>
        <span className="text-[10.5px] font-medium uppercase tracking-wider text-muted-foreground/70">
          Warm up
        </span>
      </div>

      <div className="w-full max-w-[88%] rounded-2xl rounded-tr-sm border border-border/40 bg-card/40 px-4 py-3">
        <div className="flex flex-col gap-2">
          {WARMUP_STEPS.map((step) => (
            <div key={step.label} className="flex items-center gap-2.5">
              <span className="flex size-6 shrink-0 items-center justify-center rounded-full border border-border/50 bg-background/70 text-muted-foreground/80">
                <step.icon className="size-3" />
              </span>
              <span className="text-[12.5px] text-foreground/70">{step.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
